import { useContext, useSyncExternalStore } from "react";
import { ReactReduxContext } from "react-redux";

type BillingSlice = { overContactLimit?: boolean } | undefined;

/** View-only right now (more contacts than the plan covers, grace over): the server refuses writes (403 OVER_CONTACT_LIMIT). */
export const viewOnlyOf = (billing: BillingSlice): boolean => !!billing?.overContactLimit;

const noStore = { subscribe: () => () => undefined, getState: () => ({}) };

/**
 * The account is view-only (today's `billingStore.overContactLimit`, the same source as `useBillingState().viewOnly`).
 * Where no store is mounted (a part rendered on its own) it is false: the server still refuses, this only hides.
 */
export const useViewOnly = (): boolean => {
  const store = useContext(ReactReduxContext)?.store ?? noStore;
  const read = () => viewOnlyOf((store.getState() as { billingStore?: BillingSlice }).billingStore);
  return useSyncExternalStore(store.subscribe, read, read);
};
